import React from 'react';

const ClientsList = () => {
    return (
        <div className="client-items clearfix">
            <div className="client-item">
                <div className="client-body">
                    <img src="assets/img/demo/10_img.png" alt="Logo" />
                </div>
            </div>

            <div className="client-item">
                <div className="client-body">
                    <img src="assets/img/demo/11_img.png" alt="Logo" />
                </div>
            </div>

            <div className="client-item">
                <div className="client-body">
                    <img src="assets/img/demo/13_img.png" alt="Logo" />
                </div>
            </div>

            <div className="client-item">
                <div className="client-body">
                    <img src="assets/img/demo/12_img.png" alt="Logo" />
                </div>
            </div>

            <div className="client-item">
                <div className="client-body">
                    <img src="assets/img/demo/14_img.png" alt="Logo" />
                </div>
            </div>
        </div>
    );
};

export default ClientsList;
